import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import { FIBA_TESTING_FLOW_HISTORY, GET_MASTER_COACH_NO, GET_MASTER_SHELL_NO, LIST_TESTING_FIBA, STORE_TESTING_FIBA, TESTING_AIR_BRAKE_HISTORY, TESTING_AIR_BRAKE_LIST, TESTING_AIR_BRAKE_STORE, TESTING_AIR_BRAKE_UPDATE_STATUS, TESTING_AIR_BRAKE_VIEW, TESTING_BUFFER_CBC_HISTORY, TESTING_BUFFER_CBC_LIST, TESTING_BUFFER_CBC_STORE, TESTING_BUFFER_CBC_UPDATE_STATUS, TESTING_BUFFER_CBC_VIEW, TESTING_FIBA_PARAMS, UPDATE_FIBA_TESTING_STATUS, VIEW_TESTING_FIBA } from '../../../api/apiConstant';

// Fetch FIBA Testing Params
export const fetchTestingFibaParams = createAsyncThunk(
  'furnishing/fetchTestingFibaParams',
  async (formdata, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_FIBA_PARAMS, formdata);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Store FIBA Testing Data
export const storeTestingFiba = createAsyncThunk(
  'furnishing/storeTestingFiba',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_TESTING_FIBA, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Get FIBA Testing List
export const listTestingFiba = createAsyncThunk(
  'furnishing/listTestingFiba',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_TESTING_FIBA, {params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// View FIBA Testing Data
export const viewTestingFiba = createAsyncThunk(
  'furnishing/viewTestingFiba',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_TESTING_FIBA, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Get FIBA Testing Flow History
export const getFibaTestingFlowHistory = createAsyncThunk(
  'furnishing/getFibaTestingFlowHistory',
  async (stageId, { rejectWithValue }) => {
    try {
      const response = await api.post(FIBA_TESTING_FLOW_HISTORY, { stageId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
// Update FIBA Testing Status
export const updateFibaTestingStatus = createAsyncThunk(
  'furnishing/updateFibaTestingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_FIBA_TESTING_STATUS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  }
);

// Fetch Coach Numbers by Frame Type
export const fetchCoachNoByFrameType = createAsyncThunk(
  'furnishing/fetchCoachNoByFrameType',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_MASTER_COACH_NO, {
        params: {
          frame_type_id: params.frame_type_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

// Fetch Shell Numbers by Frame Type
export const fetchShellNoByFrameType = createAsyncThunk(
  'furnishing/fetchShellNoByFrameType',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_MASTER_SHELL_NO, {
        params: {
          frame_type_id: params.frame_type_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);


// Air Brake Testing - List
export const listTestingAirBrake = createAsyncThunk(
  'furnishingTesting/listTestingAirBrake',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(TESTING_AIR_BRAKE_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Air Brake Testing - View
export const viewTestingAirBrake = createAsyncThunk(
  'furnishingTesting/viewTestingAirBrake',
  async (id, { rejectWithValue }) => {
    try {
     
            const response = await api.post(TESTING_AIR_BRAKE_VIEW, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Air Brake Testing - Store/Update
export const storeTestingAirBrake = createAsyncThunk(
  'furnishingTesting/storeTestingAirBrake',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_AIR_BRAKE_STORE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Air Brake Testing - Update Status
export const updateAirBrakeTestingStatus = createAsyncThunk(
  'furnishingTesting/updateAirBrakeTestingStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_AIR_BRAKE_UPDATE_STATUS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Air Brake Testing - Get History
export const getAirBrakeTestingHistory = createAsyncThunk(
  'furnishingTesting/getAirBrakeTestingHistory',
  async (stageId, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_AIR_BRAKE_HISTORY, { stageId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const listTestingBufferCbc = createAsyncThunk(
  'furnishingTesting/listTestingBufferCbc',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(TESTING_BUFFER_CBC_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Buffer CBC Testing - View
export const viewTestingBufferCbc = createAsyncThunk(
  'furnishingTesting/viewTestingBufferCbc',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_BUFFER_CBC_VIEW, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Buffer CBC Testing - Store/Update
export const storeTestingBufferCbc = createAsyncThunk(
  'furnishingTesting/storeTestingBufferCbc',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_BUFFER_CBC_STORE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Buffer CBC Testing - Update Status
export const updateBufferCbcTestingStatus = createAsyncThunk(
  'furnishingTesting/updateBufferCbcTestingStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_BUFFER_CBC_UPDATE_STATUS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Buffer CBC Testing - Get History
export const getBufferCbcTestingHistory = createAsyncThunk(
  'furnishingTesting/getBufferCbcTestingHistory',
  async (stageId, { rejectWithValue }) => {
    try {
      const response = await api.post(TESTING_BUFFER_CBC_HISTORY, { stageId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);